export const assignedAssetColumns = [
  {
    headerName: 'Category',
    field: 'category',
    cellRenderer: 'activityComponent',
    cellRendererParams: {
      displayType: 'icon',
    },
    width: 100,
  },
  { headerName: 'Asset ID', field: 'assetId', width: 200 },
  { headerName: 'Asset Name', field: 'assetName', width: 200 },
  { headerName: 'Assigned', field: 'lastStatusUpdated', width: 150 },
  {
    headerName: 'Status',
    field: 'currentStatus',
    width: 200,
    cellRenderer: 'conditionalBtnOrTextComponent',
  },
];
